module.exports = __webpack_public_path__ + "static/media/guillaume-prof.fab856ad.svg";